import { gql } from '@src/lib/gql'

/** Pay-first step 1 (L13): manual-capture PaymentIntent, no session row yet. */
export const PREPARE_ADVISOR_SESSION_PAYMENT = gql`
  mutation PrepareAdvisorSessionPayment($input: PrepareAdvisorSessionPaymentInput!) {
    prepareAdvisorSessionPayment(input: $input) {
      paymentRequired
      paymentIntentId
      clientSecret
      amountCents
      amountUsd
      waived
      approximateLengthMinutes
      stripeConnectAccountId
      stripeCustomerSessionClientSecret
    }
  }
`
